import { doAction } from '@situation/setdesign.util';

class NavButton {
    constructor($el) {
        this.$el = $el;
        this.increment = this.$el.hasClass('home-slider__nav__btn--next') ? 1 : -1;
        this.handleClick = this.handleClick.bind(this);
        this.$el.on('click', this.handleClick);
    }

    handleClick() {
        doAction('home-carousel/paginate', this.increment);
    }
}

export default NavButton;
